export default __webpack_public_path__ + "static/media/switch1.641a3632.svg";